import { SvgIcon } from '@material-ui/core';

export const TvSeriesIcon: typeof SvgIcon = props => {
  return (
    <SvgIcon {...props} viewBox="0 0 60 60">
      <defs>
        <style>
          {
            '.f{fill:#454a57}.g,.h{fill:none;stroke-miterlimit:10}.g{stroke:#454a57}.h{stroke:#404551;stroke-linecap:round;stroke-width:.93541px}'
          }
        </style>
      </defs>
      <title />
      <circle
        cx={30}
        cy={30}
        r={30}
        style={{
          fill: '#ffd301',
        }}
      />
      <path
        d="M57.044 43a30 30 0 1 0-54.089 0Z"
        style={{
          fill: '#ff4867',
        }}
      />
      <rect
        height={31}
        rx={4}
        ry={4}
        width={48}
        x={6}
        y={19}
        style={{
          fill: '#4f5564',
        }}
      />
      <rect
        height={32}
        rx={2}
        ry={2}
        transform="rotate(90 25 34.5)"
        width={25}
        x={12.5}
        y={18.5}
        style={{
          fill: '#25cec6',
        }}
      />
      <rect
        height={28}
        rx={1}
        ry={1}
        transform="rotate(90 25 34.5)"
        width={21}
        x={14.5}
        y={20.5}
        style={{
          fill: '#8de1de',
        }}
      />
      <path className="f" d="M29.788 19a5.495 5.495 0 0 0-10.576 0Z" />
      <circle className="f" cx={15} cy={1} r={1} />
      <circle className="f" cx={34} cy={1} r={1} />
      <path className="g" d="M25 17 15 1M24 17 34 1" />
      <path className="h" d="M44 23h7M44 25h7M44 27h7" />
      <circle
        cx={47.5}
        cy={35.5}
        r={1.5}
        style={{
          fill: '#f2572d',
        }}
      />
      <circle
        cx={47.5}
        cy={40.5}
        r={1.5}
        style={{
          fill: '#a0e48d',
        }}
      />
    </SvgIcon>
  );
};
